import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ICsvImportCompletionDTO, ICsvImportCompletionResultDTO, ICsvImportValidationResultDTO, IImportValidationDTO } from "@app/main/modules/foundation/foundation.interfaces";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class FoundationCsvImporterService {

    constructor(private readonly http: HttpClient) {

    }

    validateFile(toValidate: IImportValidationDTO): Observable<ICsvImportValidationResultDTO> {
        return this.http.post<ICsvImportValidationResultDTO>(`/api/foundation/import/validate`, toValidate)
    }

    saveFile(toSave: ICsvImportCompletionDTO): Observable<ICsvImportCompletionResultDTO> {
        return this.http.post<ICsvImportCompletionResultDTO>(`/api/foundation/import`, toSave);
    }
}
